import React, { useState } from 'react'
import { Col, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { sessionGetItemStr } from '../../utils/sessionHelpers'
import { startLoading, doneLoading } from '../../utils/loading'
import TrackingIllustration from './TrackingIllustration'
import InputForm from '../../components/forms/input/InputForm'
import ProjectMonitorRecordInputWidgets from './ProjectMonitorRecordInputWidgets'
import InputDateForm from '../../components/forms/input/InputDateForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import {
  CANCEL,
  DEFAULT_ERR_MSG,
  PROCESS_SUCCESS_MSG,
  SAVE,
  SAVE_SUCCESS_MSG,
} from '../../constants/msgText'
import { isEmpty } from 'lodash-es'
import { setAlertMessage } from '../../utils/messageUtil'
import { copyTracking, saveTracking } from '../../redux/actions/subprojectTrackingHistory'
import {
  SUB_FOLLOW_ID,
  SUB_FOLLOW_VM,
  SUB_PROJECT_CODE,
  SUB_PROJECT_ID,
} from '../../constants/constants'
import pathname from '../../constants/pathname'
import ProjectMonitorRecordViewWidgets from './ProjectMonitorRecordViewWidgets'
import TrackingSummary from './TrackingSummary'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function ProjectMonitorRecordFollowWidgets(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isRefash, setIsRefash] = useState(false)
  const [isCopy, setIsCopy] = useState(false)

  const projectCode = sessionStorage.getItem(SUB_PROJECT_CODE)
  const projectId = sessionStorage.getItem(SUB_PROJECT_ID)
  const viewMode = 'true' == sessionStorage.getItem(SUB_FOLLOW_VM)
  // const viewMode = location.search.substring(1) == 'view'

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      let response = await saveTracking(request)

      if (response) {
        sessionStorage.setItem(SUB_FOLLOW_ID, response.id)

        setFormSchema(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG)

        onRefash()
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (error) {
      console.log('error ', error)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = async (data) => {
    // console.log('onSubmit data : ', data)

    const formData = new FormData()

    formData.append('Id', formSchema.id || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('ProjectId', projectId || '')
    formData.append('DateFollow', data.dateFollow || '')
    formData.append('Summarize', data.summarize || '')
    formData.append('IsSummarize', false)

    handleSave(formData)
  }

  const handleGetPrevious = async () => {
    setIsLoading(true)
    startLoading()

    try {
      let response = await copyTracking(formSchema.id)

      if (response) {
        sessionStorage.setItem(SUB_FOLLOW_ID, response.id)

        setFormSchema(response)
        setAlertMessage('success', PROCESS_SUCCESS_MSG)
        setIsCopy(false)

        onRefash()
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (error) {
      // console.log('error ', error)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onCancel = () => {
    if (formSchema.id) {
      sessionStorage.removeItem(SUB_FOLLOW_ID)
      sessionStorage.removeItem(SUB_FOLLOW_VM)
      window.location = pathname.subProject.trackingHistory
    } else {
      onRefash()
    }
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      <Panel shaded header={formSchema.header} collapsible defaultExpanded>
        <div style={{ marginTop: -10 }}>
          {!isRefash && (
            <>
              {formSchema.followTimes && (
                <>
                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                      {formSchema.followTimes.label} : <b>{formSchema.followTimes.value}</b>
                    </Col>
                  </Row>
                </>
              )}

              {formSchema.dateFollow && (
                <>
                  {viewMode ? (
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                        {formSchema.dateFollow.label} : <b>{formSchema.dateFollow.value}</b>
                      </Col>
                    </Row>
                  ) : (
                    <InputDateForm
                      schema={formSchema.dateFollow}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      getValues={getValues}
                      clearErrors={clearErrors}
                      //startDate={sessionGetItemStr('projectStartDate')}
                      endDate={new Date()}
                    />
                  )}
                </>
              )}

              {/* {formSchema.summarize && (
                <>
                  {viewMode ? (
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                        {formSchema.summarize.label} : <b>{formSchema.summarize.value}</b>
                      </Col>
                    </Row>
                  ) : (
                    <InputForm
                      schema={formSchema.summarize}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      componentClass="textarea"
                    />
                  )}
                </>
              )} */}

              {!viewMode && (
                <>
                  <hr />
                  <div className="right">
                    {!isEmpty(formSchema.id) && formSchema.followTimes.value > 1 && (
                      <ViewButton
                        children="ตั้งต้นจากครั้งก่อนหน้า"
                        style={{
                          marginRight: 10,
                          marginBottom: 10,
                        }}
                        onClick={() => {
                          setIsCopy(true)
                        }}
                      />
                    )}

                    <SaveButton
                      children={SAVE + (formSchema.buttonText || '')}
                      disabled={isLoading || formSchema.disabled}
                      onClick={handleSubmit(onSubmit)}
                    />
                    <CancelButton children={CANCEL} onClick={onCancel} />
                  </div>
                </>
              )}

              {!isEmpty(formSchema.id) && (
                <div style={{ marginTop: 10 }}>
                  {formSchema.trackingDetails?.map((e) => {
                    return (
                      <>
                        {!viewMode ? (
                          <ProjectMonitorRecordInputWidgets
                            schema={e}
                            refId={formSchema.id}
                            viewMode={viewMode}
                          />
                        ) : (
                          <ProjectMonitorRecordViewWidgets
                            schema={e}
                            refId={formSchema.id}
                            viewMode={viewMode}
                          />
                        )}
                      </>
                    )
                  })}

                  {/* ภาพประกอบ */}
                  {formSchema.trackingIllustration && (
                    <>
                      <TrackingIllustration
                        schema={formSchema.trackingIllustration}
                        refId={formSchema.id}
                        viewMode={viewMode}
                      />
                      <br />
                    </>
                  )}

                  <TrackingSummary schema={formSchema} refId={formSchema.id} viewMode={viewMode} />
                </div>
              )}
            </>
          )}
        </div>

        <ConfirmWidget
          title={`ยืนยัน`}
          show={isCopy}
          detail={
            <>
              <p>ยืนยัน การตั้งต้นผลการติดตาม จากการติดตามครั้งก่อนหน้า</p>
              <p style={{ color: '#fb8a81' }}>
                <u>
                  <i>" ผลการติดตามครั้งนี้จะถูกแทนที่ด้วย ผลการติดตามครั้งก่อนหน้า "</i>
                </u>
              </p>
            </>
          }
          size="sm"
          onCancle={() => setIsCopy(false)}
          onConfirm={handleGetPrevious}
        />
      </Panel>
    </>
  )
}
